import { BadgeCheck, Flame } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import type { Property } from '@/types/property'

export function PropertyBadges({
  property,
  className,
  compact = false,
  showIntent = true,
}: {
  property: Pick<Property, 'isVerified' | 'isHot' | 'isPremium' | 'intent'>
  className?: string
  compact?: boolean
  showIntent?: boolean
}) {
  const badgeClass = compact
    ? 'normal-case px-1.5 py-0 text-[10px] shadow-sm [&_svg]:h-2.5 [&_svg]:w-2.5'
    : 'normal-case'

  const hasStatusBadge = property.isVerified || property.isHot
  if (!hasStatusBadge && !showIntent) return null

  const intentVariant =
    property.intent === 'rent' ? 'rent' : property.intent === 'commercial' ? 'commercial' : 'sale'
  const intentLabel =
    property.intent === 'rent' ? 'For Rent' : property.intent === 'commercial' ? 'Commercial' : 'For Sale'

  return (
    <div className={cn('flex flex-wrap gap-1', compact ? 'gap-1' : 'gap-1.5', className)}>
      {property.isVerified && (
        <Badge variant="verified" className={badgeClass}>
          <BadgeCheck className="h-3 w-3" /> QBC Verified
        </Badge>
      )}
      {property.isHot && (
        <Badge variant="hot" className={badgeClass}>
          <Flame className="h-3 w-3" /> Hot
        </Badge>
      )}
      {showIntent ? (
        <Badge variant={intentVariant} className={badgeClass}>
          {intentLabel}
        </Badge>
      ) : null}
    </div>
  )
}
